import { trackerLog } from '@enuygun/frontend-components'
import Cookies from 'js-cookie'

const serverId = Cookies.get('SERVERID-SAG') || Cookies.get('SERVERID-SH')

type TrackerPayload = {
  category?: string
  page?: string
  type?: string
  message?: string
  environment?: string
  requestId?: string
  // Allow arbitrary extra fields without breaking callers
  [key: string]: unknown
}

const sendTrackerLog = ({ category = 'transfer', page = '', type = '', message = '', environment = '', requestId, ...rest }: TrackerPayload) => {
  trackerLog({
    category: category,
    page: page,
    type: type,
    message: message,
    environment: environment,
    host_name: serverId,
    request_id: requestId,
    ...rest,
  })
}

export default sendTrackerLog
